import { render, staticRenderFns } from "./Delivery-Listing-Template.vue?vue&type=template&id=5f5cccf9"
import script from "./Delivery-Listing-Template.vue?vue&type=script&lang=js"
export * from "./Delivery-Listing-Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports